import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {},
    crosshairH: {
        width: "100%",
        height: "2px",
        marginTop: "-0px",
    },
    crosshairV: {
        height: "100%",
        width: "2px",
        marginLeft: "-1px",
        top: "0px",
    },
    hair: {
        position: "fixed",
        backgroundColor: "rgba(100,100,100,0.5)",
        boxShadow: "0 0 0px rgb(100,100,100)",
        zIndex: 1,
        pointerEvents: "none",
    },
});

export default function HeaderBar(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    React.useEffect(() => {
        const setFromEvent = (e) => setPosition({ x: e.clientX, y: e.clientY });
        window.addEventListener("mousemove", setFromEvent);

        return () => {
            window.removeEventListener("mousemove", setFromEvent);
        };
    }, []);

    return (
        <>
            <div id="crosshair-h" className={classes.crosshairH + " " + classes.hair} style={{ top: position.y }}></div>
            <div
                id="crosshair-v"
                className={classes.crosshairV + " " + classes.hair}
                style={{ left: position.x }}
            ></div>
        </>
    );
}
